import { OTA_Equipment } from "./ota_equipment.model";
import { OTA_Charge } from "./ota_charge.model";

export class OTA_PricedEquip {
    public equipment = new OTA_Equipment();
    public charge = new OTA_Charge();
    public requestedCount = 0;
    //public maxCount = 0;

    static pricedEquipTotal(eq: OTA_PricedEquip): number {
        var total: number = 0;

        if (eq.charge.calculations != null) {
            eq.charge.calculations.forEach(function (calc) {
                total = total + calc.total;
            });
        }

        return total;
    }
}